import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'

class Temoignages extends Component {
  render() {
    return (
    <div>   
    	 <section id="testimonial" className="overlay-dark80 dark-bg ptb ptb-sm-80" style={{backgroundImage:'url("/assets/img/images/new_images/5.jpg")'}} data-stellar-background-ratio="0.5">
            <div className="container testi">
                <div className="owl-carousel testimonial-carousel nf-carousel-theme white">
                    <div className="item">
                        <div className="testimonial text-center dark-color">
                            <div className="container-icon"><i className="fa fa-quote-right"></i></div>
                            <p className="lead">" I got a dummy for Christmas and started teaching myself. I got books and records and sat in front of the practising. I did my first show in the third grade and just kept going. "</p>
                            <h6 className="quote-author">Jeff Dunham <span>( Appel Studio )</span></h6>
                        </div>
                    </div>
                    <div className="item">
                        <div className="testimonial text-center dark-color">
                            <div className="container-icon"><i className="fa fa-quote-right"></i></div>
                            <p className="lead">" I got a dummy for Christmas and started teaching myself. I got books and records and sat in front of the practising. I did my first show in the third grade and just kept going. "</p>
                            <h6 className="quote-author">Alexander Theroux <span>( USA )</span></h6>
                        </div>
                    </div>
                    <div className="item">
                        <div className="testimonial text-center dark-color">
                            <div className="container-icon"><i className="fa fa-quote-right"></i></div>
                            <p className="lead">" I got a dummy for Christmas and started teaching myself. I got books and records and sat in front of the practising. I did my first show in the third grade and just kept going. "</p>
                            <h6 className="quote-author">Adam Savage <span>( Artist )</span></h6>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
       
        

    )
  }
}
export default Temoignages;


// WEBPACK FOOTER //
// ./src/components/testimonial.jsx